import React from 'react';

export interface NavItem {
  id: string;
  label: string;
  icon: React.ElementType;
  path?: string;
  action?: () => void;
  badge?: number;
  isActive?: boolean;
  dataTourHome?: string;
  dataTour?: string;
}

interface SidebarNavItemProps {
  item: NavItem;
  isCollapsed: boolean;
  onNavigate: (path: string) => void;
  onMouseEnter?: (e: React.MouseEvent, itemId: string) => void;
  onMouseLeave?: () => void;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = ({
  item,
  isCollapsed,
  onNavigate,
  onMouseEnter,
  onMouseLeave,
}) => {
  const Icon = item.icon;
  const isActive = item.isActive;

  const handleClick = () => {
    if (item.action) {
      item.action();
    } else if (item.path) {
      onNavigate(item.path);
    }
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={(e) => onMouseEnter?.(e, item.id)}
      onMouseLeave={onMouseLeave}
      data-tour-home={item.dataTourHome}
      data-tour={item.dataTour}
      className={`w-full flex items-center gap-3 rounded-lg transition ${
        isCollapsed ? 'p-2.5 justify-center' : 'py-2.5 px-3 justify-start'
      } ${isActive ? 'bg-white' : 'hover:bg-neutral-200/60'}`}
    >
      <Icon
        className={`w-5 h-5 flex-shrink-0 ${isActive ? 'text-neutral-900' : 'text-neutral-500'}`}
      />
      {!isCollapsed && (
        <>
          <span
            className={`flex-1 text-left text-13 truncate ${
              isActive ? 'text-neutral-900 font-medium' : 'text-neutral-600'
            }`}
          >
            {item.label}
          </span>
          {item.badge && (
            <span className="px-1.5 py-0.5 text-2xs font-medium rounded-full bg-neutral-200 text-neutral-500">
              {item.badge}
            </span>
          )}
        </>
      )}
    </button>
  );
};
